export const setColumnsVisibilityModel = (
  columns,
  visibilityField,
  matchesQuery
) => {
  return columns
    .filter(column => !column[visibilityField])
    .reduce((obj, column) => ({ ...obj, [column.field]: matchesQuery }), {});
};
